function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-return-assign */
import PropTypes from 'prop-types';
import React, { Component } from 'react';

var GroupedBarChartYaxis =
/*#__PURE__*/
function (_Component) {
  _inherits(GroupedBarChartYaxis, _Component);

  function GroupedBarChartYaxis() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, GroupedBarChartYaxis);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GroupedBarChartYaxis)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "prependForeground", function (textNode) {
      var _textNode$getBBox = textNode.getBBox(),
          x = _textNode$getBBox.x,
          y = _textNode$getBBox.y,
          width = _textNode$getBBox.width,
          height = _textNode$getBBox.height;

      var foreground = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      foreground.setAttributeNS(null, 'x', x);
      foreground.setAttributeNS(null, 'y', y);
      foreground.setAttributeNS(null, 'width', width);
      foreground.setAttributeNS(null, 'height', height);
      foreground.setAttributeNS(null, 'fill', '#fff');
      foreground.setAttribute('class', 'GroupedBarChartYaxis-foreground');
      textNode.parentNode.insertBefore(foreground, textNode);
    });

    return _this;
  }

  _createClass(GroupedBarChartYaxis, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var ticks = this.props.ticks;
      /**
       * Because SVG text cannot have foreground/background, it can be achievable
       * only using background rectangles under the text with chart background color
       */

      ticks.forEach(function (tick, i) {
        if (_this2["_tick".concat(i)]) _this2.prependForeground(_this2["_tick".concat(i)]);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          ticks = _this$props.ticks,
          ticksFormat = _this$props.ticksFormat,
          scale = _this$props.scale,
          height = _this$props.height,
          width = _this$props.width,
          xOffset = _this$props.xOffset,
          yOffset = _this$props.yOffset;
      return React.createElement("g", null, React.createElement("line", {
        y1: yOffset,
        y2: height,
        x1: xOffset,
        x2: xOffset,
        className: "GroupedBarChartYaxis-line"
      }), ticks.map(function (tick, i) {
        return React.createElement("g", {
          key: i
        }, React.createElement("line", {
          y1: scale(tick),
          y2: scale(tick),
          x1: 0,
          x2: width,
          className: "GroupedBarChartYaxis-tick"
        }), i !== 0 ? React.createElement("g", null, React.createElement("text", {
          x: 0,
          y: scale(tick),
          className: "GroupedBarChartYaxis-label",
          ref: function ref(el) {
            return _this3["_tick".concat(i)] = el;
          }
        }, ticksFormat(tick))) : null);
      }));
    }
  }]);

  return GroupedBarChartYaxis;
}(Component);

_defineProperty(GroupedBarChartYaxis, "propTypes", {
  ticks: PropTypes.arrayOf(PropTypes.number).isRequired,
  ticksFormat: PropTypes.func.isRequired,
  scale: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  xOffset: PropTypes.number.isRequired,
  yOffset: PropTypes.number.isRequired
});

export default GroupedBarChartYaxis;